export default __webpack_public_path__ + "static/media/call-outline.65fd53dc.svg";